import cls from './Card.module.scss'
import { Round } from 'shared/ui/Round'
import background from '../../../shared/assets/images/cardBack.jpg'
import { animated } from '@react-spring/web'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import reject from 'shared/assets/images/reject.png'
import accept from 'shared/assets/images/accept.png'
import want from 'shared/assets/images/want.png'
import { authActions } from 'features/anonymousAuth'
import { parser } from 'shared/lib/parser/parser'
import { classNames } from 'shared/lib/classNames/classNames'
import imgBlocked from 'shared/assets/images/blocked.png'
import { Text, TextColor, TextSize, TextWeight } from 'shared/ui/Text/Text'
import { useNavigate } from 'react-router-dom'
import { fetchPublicProfileData } from 'shared/api/fetchPublicProfileData'
import { setCurrentFriend } from 'shared/api/setCurrentFriend'
import React from 'react'
import { ImageWithSkeleton } from 'shared/ui/ImageWithSkeleton'

export const iconEnum = {
    REJECT: reject,
    WANT: want,
    ACCEPT: accept,
}

export const swipeTextEnum = {
    REJECT: 'Пропустить',
    WANT: 'Хочу',
    ACCEPT: 'Сделано',
}

export const sizeEnum = {
    SMALL: 'small',
    LARGE: 'large', //дефолтная карточка
    MICRO: 'micro',
}

export const ColorEnum = {
    // Список цветов
    FIRST: 'First',
    SECOND: 'Second',
    THIRD: 'Third',
    FOURTH: 'Fourth',
    FIFTH: 'Fifth',
    SIXTH: 'Sixth',
    SEVENTH: 'Seventh',
    EIGHTH: 'Eighth',
    NINTH: 'Ninth',
    TENTH: 'Tenth',
    ELEVENTH: 'Eleventh',
    TWELFTH: 'Twelfth',
    THIRTEENTH: 'Thirteenth',
    FOURTEENTH: 'Fourteenth',
    YELLOW: 'Yellow',
    PURPLE: 'Purple',
    BLUE: 'Blue',
    GREEN: 'Green',
    PINK: 'Pink',
    ORANGE: 'Orange',
    WHITE: 'White',
    BLACK: 'Black',
}

export const BlockedCard = {
    BLACK: 'blockedBlack',
    WHITE: 'blockedWhite',
}

export const Card = (props) => {
    const {
        className,
        size,
        status,
        style,
        id,
        handlers,
        gradient,
        icon,
        changeState,
        blocked,
        disabledRound,
        readonly,
        userId,
        switcher,
    } = props
    let { text, image, color } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [userData, setUserData] = useState({})
    const [friendSaving, setFriendSaving] = useState(false)
    const [friendError, setFriendError] = useState(false)

    const myFriends = useSelector((state) => state.auth.friends)
    const myId = useSelector((state) => state.auth.id)

    if (blocked === 'blockedBlack') {
        text = 'Закрытое достижение'
        image = imgBlocked
        color = 'BLACK'
    } else if (blocked === 'blockedWhite') {
        // image = imgBlockedWhite
        text = 'Закрытое достижение'
        color = 'WHITE'
    }

    useEffect(() => {
        let active = true
        if (userId === undefined || userId === null) {
            setUserData({})
            return () => {
                active = false
            }
        }

        fetchPublicProfileData(userId)
            .then((profile) => {
                if (active) setUserData(profile || {})
            })
            .catch((error) => {
                console.error('Ошибка при загрузке автора карточки:', error)
            })
        return () => {
            active = false
        }
    }, [userId])

    const openProfile = () => {
        if (userData.nickname) {
            navigate(`/${userData.nickname}`)
        } else {
            navigate(`/${userData.id}`)
        }
    }

    const addFriend = async () => {
        if (friendSaving) return

        const shouldAdd = !myFriends.includes(userId)
        setFriendError(false)
        setFriendSaving(true)
        try {
            await setCurrentFriend(userId, shouldAdd)
            dispatch(
                shouldAdd
                    ? authActions.addFriend(userId)
                    : authActions.deleteFriend(userId)
            )
        } catch (error) {
            console.error('Ошибка при обновлении списка друзей:', error)
            setFriendError(true)
        } finally {
            setFriendSaving(false)
        }
    }

    const rndColor = ColorEnum[color]

    const parsedText = parser(text)

    const mods = {
        [cls[rndColor]]: true,
    }

    const imageMods = {
        [cls.blockedImage]: blocked === 'blockedWhite',
    }

    const textMods = {
        [cls[blocked]]: blocked,
    }

    const friendsButtonMods = {
        [cls.friend]: myFriends.includes(userId),
    }

    if (size === 'small') {
        return (
            <animated.div
                style={style}
                className={classNames(cls.Card, mods, [cls.SmallCard])}
                // variants={variants}
                // initial={initial}
                // animate={animate}
                // exit={exit}
                // transition={transition}
            >
                <>
                    <div
                        className={classNames(cls.Text, textMods, [
                            cls.SmallText,
                        ])}
                    >
                        <b>{parsedText[0]}</b> {parsedText[1]}
                    </div>
                    <ImageWithSkeleton
                        className={classNames(cls.CardImage, imageMods, [])}
                        alt="cardImage"
                        onLoad={() => dispatch(authActions.isLoaded())}
                        src={image}
                    />
                </>
                {!blocked && switcher !== 'created' ? (
                    <Round
                        disabledRound={disabledRound}
                        status={status}
                        changeState={
                            changeState ? () => changeState(status, id) : null
                        }
                        readonly={readonly}
                    />
                ) : null}
                <img
                    className={cls.SmallBackground}
                    src={background}
                    alt="back"
                />
            </animated.div>
        )
    } else if (size === 'large') {
        return (
            <animated.div
                {...handlers}
                style={style}
                className={classNames(cls.Card, mods, [])}
            >
                <>
                    <div className={cls.Container} style={gradient}>
                        {icon ? (
                            <img
                                className={cls.SwipeIcon}
                                src={icon}
                                alt="icon"
                            />
                        ) : null}
                    </div>
                    <div className={cls.Text}>
                        <b>{parsedText[0]}</b> {parsedText[1]}
                    </div>
                    {userData.avatar ? (
                        <div className={cls.UserInfo}>
                            <div
                                onClick={openProfile}
                                className={cls.UserInfoAvatar}
                            >
                                <ImageWithSkeleton
                                    className={cls.UserInfoAvatar}
                                    src={userData.avatar}
                                    alt="avatar"
                                />
                            </div>
                            <Text
                                className={cls.UserInfoName}
                                color={TextColor.SECBLACK}
                                weight={TextWeight.SBOLD}
                                size={TextSize.XS}
                                onClick={openProfile}
                            >
                                {userData.nickname
                                    ? `@${userData.nickname}`
                                    : `@${userData.id}`}
                            </Text>
                            {myId !== userId ? (
                                <button
                                    disabled={friendSaving}
                                    className={classNames(
                                        cls.AddFriendButton,
                                        friendsButtonMods,
                                        []
                                    )}
                                    onClick={addFriend}
                                >
                                    {friendError
                                        ? 'Ошибка'
                                        : myFriends.includes(userId)
                                          ? 'В друзьях'
                                          : 'В друзья'}
                                </button>
                            ) : null}
                        </div>
                    ) : null}
                    <ImageWithSkeleton
                        className={cls.CardImage}
                        alt="cardImage"
                        onLoad={() => dispatch(authActions.isLoaded())}
                        src={image}
                    />
                </>
                <img className={cls.Background} src={background} alt="back" />
            </animated.div>
        )
    } else if (size === 'micro') {
        return (
            <animated.div
                className={classNames(cls.MicroCard, mods, [className])}
            >
                <>
                    <div className={classNames(cls.MicroText, textMods, [])}>
                        <b>{parsedText[0]}</b> {parsedText[1]}
                    </div>
                    <ImageWithSkeleton
                        className={cls.MicroCardImage}
                        alt="cardImage"
                        onLoad={() => dispatch(authActions.isLoaded())}
                        src={image}
                    />
                </>
                <img
                    className={cls.MicroBackground}
                    src={background}
                    alt="back"
                />
            </animated.div>
        )
    }
}
